import { render, staticRenderFns } from "./OnboardingDashboardSelection.vue?vue&type=template&id=7333dcbf&scoped=true&"
import script from "./OnboardingDashboardSelection.vue?vue&type=script&lang=js&"
export * from "./OnboardingDashboardSelection.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingDashboardSelection.vue?vue&type=style&index=0&id=7333dcbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7333dcbf",
  null
  
)

export default component.exports